// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__3o0HP","info":"UpdateTermsInfo_info__A6uMA"};